import { matchPathsWithChat } from "@/utils/LocationUtils";
import React, { createContext, useContext, useEffect, useState } from "react";

interface RightDrawerContextType {
  isOpen: boolean;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
  isOnAnotherPage: boolean;
  setIsOnAnotherPage: React.Dispatch<React.SetStateAction<boolean>>;
  entityExternalId: string;
  setEntityExternalId: React.Dispatch<React.SetStateAction<string>>;
}

const RightDrawerContext = createContext<RightDrawerContextType | undefined>(undefined);

export function RightDrawerProvider({ children }: React.PropsWithChildren) {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [isOnAnotherPage, setIsOnAnotherPage] = useState<boolean>(false);
  const [entityExternalId, setEntityExternalId] = useState<string>(null);

  const contextValue: RightDrawerContextType = {
    isOpen,
    setIsOpen,
    isOnAnotherPage,
    setIsOnAnotherPage,
    entityExternalId,
    setEntityExternalId,
  };

  useEffect(() => {
    // Reset entity external id on page change
    // This allows for fetching specific conversation list depending on
    // entity
    setEntityExternalId(null);
    if (location && matchPathsWithChat(location)) {
      setIsOnAnotherPage(false);
      return;
    }
    setIsOnAnotherPage(true);
  }, [location?.pathname]);

  return <RightDrawerContext.Provider value={contextValue}>{children}</RightDrawerContext.Provider>;
}

export function useRightDrawer(): RightDrawerContextType {
  const context = useContext(RightDrawerContext);

  return context!;
}
